export const toLngLat = ([lat, lng]: [number, number]): [number, number] => [
  lng,
  lat,
];

export const toLngLatMap = (
  coords: [number, number] | undefined | null,
): [number, number] | null => {
  if (
    Array.isArray(coords) &&
    coords.length === 2 &&
    typeof coords[0] === "number" &&
    typeof coords[1] === "number"
  ) {
    const [lat, lng] = coords;
    return [lng, lat];
  }
  return null;
};
